import React from "react"
import { Navigate, useParams } from "react-router-dom"

export const withAuthenticationRedirect = (Component) => {
    return (props) => {
        const { id } = useParams()
        const isLoggedin = Boolean(window.userdata && Object.keys(window.userdata || {}).length > 0)
        const isCampaignPage = window.location.pathname.includes(`/campaign/${id}/`)
        const campaignURL = isCampaignPage ? `/campaign/${id}/` : "/sign_up/"

        return isLoggedin ? <Component {...props} /> : <Navigate to={campaignURL} />
    }
}
